/**
 * SPEC-034 § 7.2 (lot 1.5, slice 5): a secret is sealed in the browser with the
 * public key of the GitHub environment (libsodium sealed box, the format
 * GitHub's API asks for). The portal's backend only ever sees the sealed value.
 */
export async function sealForGithub(value: string, base64Key: string): Promise<string> {
  const { default: sodium } = await import('libsodium-wrappers');
  await sodium.ready;
  const key = sodium.from_base64(base64Key, sodium.base64_variants.ORIGINAL);
  return sodium.to_base64(sodium.crypto_box_seal(sodium.from_string(value), key), sodium.base64_variants.ORIGINAL);
}

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

/** § 3.3 @generate N: N random characters, drawn in the browser (rejection sampling, no modulo bias). */
export function generateSecret(length: number, random: (bytes: Uint8Array) => Uint8Array = b => crypto.getRandomValues(b)): string {
  let out = '';
  while (out.length < length) {
    for (const byte of random(new Uint8Array(length * 2))) {
      if (byte < 248 && out.length < length) out += ALPHABET[byte % 62];
    }
  }
  return out;
}
